import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const Contenter = withStyles(styles)(props => {
  const { contents, type, inc, count, classes, key } = props
  const data = contents.filter(x => x.type === type)[count[type]].content
  inc(type)
  return (
    data && (
      <div className={classes.page} key={key}>
        <div className={classes.contents}>
          <div className={classes.contenter}>
            <div className={classes.layout}>
              <Grid container spacing={40}>
                <Grid item xs={12}>
                  <Typography variant="headline">
                    {data.primary.title.text}
                  </Typography>
                  <Typography variant="subheading">
                    {data.primary.subtitle1.text}
                  </Typography>
                </Grid>
                {data.items.map((item, i) => {
                  return (
                    <Grid item xs={12} key={i}>
                      {item.image.localFile && (
                        <div
                          className={classes.contenterImage}
                          src={item.image.localFile.childImageSharp.original}
                          style={{
                            backgroundImage: `url(${
                              item.image.localFile.childImageSharp.original.src
                            })`,
                          }}
                        />
                      )}
                      <Typography variant="headline">
                        {item.title.text}
                      </Typography>
                      <Typography variant="subheading">
                        {item.subtitle1.text}
                      </Typography>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.content && item.content.html,
                        }}
                        className={classes.richText}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    )
  )
})

export default withStyles(styles)(Contenter)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/contenter.js